import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DiscountsTab({ token }) {
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newCode, setNewCode] = useState({ code: '', percentage: 10 });

  const fetchCodes = () => {
    fetch(`${API_URL}/api/admin/discount-codes`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setCodes(data.discount_codes || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchCodes(); }, [token]);

  const createCode = async () => {
    if (!newCode.code) return;
    try {
      const res = await fetch(`${API_URL}/api/admin/discount-codes`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: newCode.code, discount_percent: newCode.percentage })
      });
      if (res.ok) {
        toast.success('Code created!');
        setNewCode({ code: '', percentage: 10 });
        fetchCodes();
      } else {
        const err = await res.json();
        toast.error(err.detail || 'Failed to create');
      }
    } catch (err) {
      toast.error('Failed');
    }
  };

  const deleteCode = async (id) => {
    await fetch(`${API_URL}/api/admin/discount-codes/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    toast.success('Deleted');
    fetchCodes();
  };

  if (loading) return <div className="text-white">Loading...</div>;

  return (
    <div className="space-y-6">
      <Card className="bg-slate-800 border-slate-700">
        <CardHeader>
          <CardTitle className="text-white">Create Discount Code</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="text-slate-400 text-sm">Code</label>
              <Input
                value={newCode.code}
                onChange={(e) => setNewCode({ ...newCode, code: e.target.value.toUpperCase() })}
                placeholder="SAVE20"
                className="bg-slate-700 border-slate-600 text-white"
              />
            </div>
            <div className="w-32">
              <label className="text-slate-400 text-sm">Discount %</label>
              <Input
                type="number"
                value={newCode.percentage}
                onChange={(e) => setNewCode({ ...newCode, percentage: parseInt(e.target.value) || 0 })}
                className="bg-slate-700 border-slate-600 text-white"
              />
            </div>
            <Button onClick={createCode}>Create</Button>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-slate-800 border-slate-700">
        <CardHeader>
          <CardTitle className="text-white">Active Codes ({codes.length})</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {codes.map((code) => (
              <div key={code.id} className="flex items-center justify-between p-3 bg-slate-700 rounded-lg">
                <div>
                  <span className="text-white font-mono font-bold">{code.code}</span>
                  <span className="text-green-400 ml-3">{code.discount_percent}% off</span>
                  <span className="text-slate-400 ml-3 text-sm">Used: {code.times_used || 0}x</span>
                </div>
                <Button variant="destructive" size="sm" onClick={() => deleteCode(code.id)}>Delete</Button>
              </div>
            ))}
            {codes.length === 0 && <p className="text-slate-400 text-center py-4">No codes yet</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
